/*
 * Module for the Death Audit Export job parameter page
 */
rs.module("content/jobs/criteria/deathauditexport",

    [ /* dependencies */ ],

    function () {

        function initialize(jsSelectors, cssSelectors) {

            // unpack js selectors
            var parameters = $.js(jsSelectors.parameters);

            var providerDetailContainer = parameters.js(jsSelectors.providerDetailContainer);
            var providerDetailPanel = parameters.js(jsSelectors.providerDetailPanel);

            var providerSelect = parameters.js(jsSelectors.providerSelect);
            var providerDetailItems = parameters.js(jsSelectors.providerDetailItem, { required: false, multiple: true });
            var providerDetailEmpty = parameters.js(jsSelectors.providerDetailEmpty);

            // show/hide service provider detail on hover
            providerDetailContainer.hoverIntent({
                handlerOver: function () {
                    providerDetailPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function () {
                    providerDetailPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

            // register provider change event
            providerSelect.change(providerSelected);

            // run on DOM ready
            $(providerSelected);

            // show/hide provider details in popup based on selected provider
            function providerSelected() {

                // hide all detail rows first
                providerDetailItems.hide();
                providerDetailEmpty.hide();

                var hasDetails = false;

                // for each detail row, determine if it applies to selected provider, and show it if so
                providerDetailItems.each(function () {

                    if (providerSelect.val() == $(this).data("providerkey")) {

                        hasDetails = true;
                        $(this).show();
                    }
                });

                // if no provider details are being shown, configure the empty message and show it
                if (!hasDetails) {

                    var message = providerSelect.val() ? `No provider details.` : `No provider ${ providerDetailItems.length == 0 ? "defined" : "selected" }.`;

                    providerDetailEmpty.js(jsSelectors.providerDetailItemText).text(message);
                    providerDetailEmpty.show();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);